import type {
  AnalysisVerificationResult,
  SpectralAnalysisSnapshot,
} from '../types';
import { buildLocalVerificationReport } from './buildLocalVerificationReport';
import { buildVerificationEvidence } from './buildVerificationEvidence';
import { VERIFICATION_MODEL } from './constants';
import { resolveVerificationSnapshot } from './resolveVerificationSnapshot';
import type { VerificationHrDataSource } from './resolveVerificationSnapshot';
import { runDeterministicChecks } from './runDeterministicChecks';

export const verifySpectralAnalysis = async (
  snapshot: SpectralAnalysisSnapshot
): Promise<AnalysisVerificationResult> => {
  const checkedAt = new Date().toISOString();

  let resolvedSnapshot = snapshot;
  let dataSourcesBySessionId: Record<number, VerificationHrDataSource> = {};

  try {
    const resolved = await resolveVerificationSnapshot(snapshot);
    resolvedSnapshot = resolved.snapshot;
    dataSourcesBySessionId = resolved.dataSourcesBySessionId;
  } catch (error) {
    return {
      status: 'failed',
      notes: [
        error instanceof Error
          ? error.message
          : 'Impossibile caricare i dati sessione per la verifica.',
      ],
      model: VERIFICATION_MODEL,
      checkedAt,
    };
  }

  const deterministicChecks = runDeterministicChecks(resolvedSnapshot);
  const deterministicPassed = deterministicChecks.every(check => check.passed);
  const evidence = buildVerificationEvidence(
    resolvedSnapshot,
    dataSourcesBySessionId
  );
  const report = buildLocalVerificationReport(
    evidence,
    deterministicChecks,
    deterministicPassed
  );

  const notes = [
    report.summary,
    ...deterministicChecks
      .filter(check => !check.passed)
      .map(check => check.message),
  ].filter(Boolean);

  return {
    status: report.status,
    notes,
    model: VERIFICATION_MODEL,
    checkedAt,
    deterministicChecks,
    aiFindings: report.findings,
  };
};
